import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getJwtToken, getBranchId } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaLoanTypes, } from './sagaLoanRedux';
import OfferActions from '../sagaOffer/sagaOfferRedux';
import ContractActions from '../sagaContract/sagaContractRedux';
import DeedActions from '../sagaDeed/sagaDeedRedux';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';

export function* requestUpdateOldLoan(action) {
    const tag = '[REQUEST_UPDATE_OLD_LOAN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOldLoan, jwtToken, action.loan, action.propertyId, action.parentId, action.parentType, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOldLoan response :`, response.data);
                yield put(Actions.updateOldLoanSuccess(response.data.result.oldLoan));
                if (action.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOldLoan failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOldLoanFailure(message));
    }
}

export function* requestOldLoanTakeOver(action) {
    const tag = '[REQUEST_OLD_LOAN_TAKE_OVER]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestOldLoanTakeOver, jwtToken, action.loan, action.propertyId, action.parentId, action.parentType, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestOldLoanTakeOver response :`, response.data);
                yield put(Actions.oldLoanTakeOverSuccess(response.data.result.oldLoan));
                if (action.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestOldLoanTakeOver failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.oldLoanTakeOverFailure(message));
    }
}

export function* requestUpdateILSLoan(action) {
    const tag = '[REQUEST_UPDATE_I_L_S_LOAN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateILSLoan, jwtToken, action.ILSLoan, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateILSLoan response :`, response.data);
                yield put(Actions.updateILSLoanSuccess(response.data.result.loanc));
                if (action.ILSLoan.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                    console.log('offer');
                } else if (action.ILSLoan.parentType === 'Contract') {
                    console.log('Contract');
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.ILSLoan.parentType === 'Deed') {
                    console.log('Deed');
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateILSLoan failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateILSLoanFailure(message));
    }
}

export function* requestRemoveTakenLoan(action) {
    const tag = '[REQUEST_REMOVE_TAKEN_LOAN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestRemoveTakenLoan, jwtToken, action.loanId, action.propertyId, action.parentId, action.parentType, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemoveTakenLoan response :`, response.data);
                yield put(Actions.removeTakenLoanSuccess(response.data.result.oldLoan));
                if (action.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemoveTakenLoan failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removeTakenLoanFailure(message));
    }
}

export function* requestUpdateNewLoan(action) {
    const tag = '[REQUEST_UPDATE_NEW_LOAN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateNewLoan, jwtToken, action.loan, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateNewLoan response :`, response.data);
                yield put(Actions.updateNewLoanSuccess(response.data.result.loanId));
                if (action.loan.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.loan.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.loan.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateNewLoan failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateNewLoanFailure(message));
    }
}

export function* requestRemoveNewLoan(action) {
    const tag = '[REQUEST_REMOVE_NEW_LOAN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestRemoveNewLoan, jwtToken, action.loanId, action.parentId, action.parentType, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemoveNewLoan response :`, response.data);
                yield put(Actions.removeNewLoanSuccess(response.data.result.isUpdated));
                if (action.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemoveNewLoan failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removeNewLoanFailure(message));
    }
}

export function* requestUpdateLoanTitle(action) {
    const tag = '[REQUEST_UPDATE_LOAN_TITLE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateLoanTitle, jwtToken, action.refId, action.refType, action.title, action.loanType);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateLoanTitle response :`, response.data);
                yield put(Actions.updateLoanTitleSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateLoanTitle failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateLoanTitleFailure(message));
    }
}

export function* requestUpdateBond(action) {
    const tag = '[REQUEST_UPDATE_BOND]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateBond, jwtToken, action.loan, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateBond response :`, response.data);
                yield put(Actions.updateBondSuccess(response.data.result.loanId));
                if (action.loan.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.loan.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.loan.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateBond failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateBondFailure(message));
    }
}

export function* requestRemoveBond(action) {
    const tag = '[REQUEST_REMOVE_BOND]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestRemoveBond, jwtToken, action.loanId, action.parentId, action.parentType, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemoveBond response :`, response.data);
                yield put(Actions.removeBondSuccess(response.data.result.isUpdated));
                if (action.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemoveBond failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removeBondFailure(message));
    }
}

export function* requestUpdateLoanDate(action) {
    const tag = '[REQUEST_UPDATE_LOAN_DATE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateLoanDate, jwtToken, action.refId, action.refType, action.contractDate, action.contractDeedDue, action.transferDate, action.previousDeedDueDate,action.transferDateText);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateLoanDate response :`, response.data);
                yield put(Actions.updateLoanDateSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateLoanDate failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateLoanDateFailure(message));
    }
}

export function* requestRemoveILSLoan(action) {
    const tag = '[REQUEST_REMOVE_I_L_S_LOAN]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestRemoveILSLoan, jwtToken, action.loanId, branchId, culture, action.parentId, action.parentType);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemoveILSLoan response :`, response.data);
                yield put(Actions.removeILSLoanSuccess(response.data.result.isUpdated));
                if (action.parentType === 'Offer') {
                    yield put(OfferActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Contract') {
                    yield put(ContractActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                } else if (action.parentType === 'Deed') {
                    yield put(DeedActions.requestUpdateFinancialStatement(response.data.result.financialStatement));
                }
                // window.top.location.href = document.referrer;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemoveILSLoan failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removeILSLoanFailure(message));
    }
}


export default function* rootSaga() {
    yield all([
        takeLatest(SagaLoanTypes.REQUEST_UPDATE_OLD_LOAN, requestUpdateOldLoan),
        takeLatest(SagaLoanTypes.REQUEST_OLD_LOAN_TAKE_OVER, requestOldLoanTakeOver),
        takeLatest(SagaLoanTypes.REQUEST_UPDATE_I_L_S_LOAN, requestUpdateILSLoan),
        takeLatest(SagaLoanTypes.REQUEST_REMOVE_TAKEN_LOAN, requestRemoveTakenLoan),
        takeLatest(SagaLoanTypes.REQUEST_UPDATE_NEW_LOAN, requestUpdateNewLoan),
        takeLatest(SagaLoanTypes.REQUEST_REMOVE_NEW_LOAN, requestRemoveNewLoan),
        takeLatest(SagaLoanTypes.REQUEST_UPDATE_LOAN_TITLE, requestUpdateLoanTitle),
        takeLatest(SagaLoanTypes.REQUEST_UPDATE_BOND, requestUpdateBond),
        takeLatest(SagaLoanTypes.REQUEST_REMOVE_BOND, requestRemoveBond),
        takeLatest(SagaLoanTypes.REQUEST_UPDATE_LOAN_DATE, requestUpdateLoanDate),
        takeLatest(SagaLoanTypes.REQUEST_REMOVE_I_L_S_LOAN, requestRemoveILSLoan),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaLoan/sagaLoanSaga.ts